import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/tag.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import ReactUtils from '../../packages/react-utils/react-utils.js';
import PropsUtils from '../../packages/props-utils/props-utils.js';
import { TAG_APPEARANCES, TAG_ELEMS } from './types.js';
import Button from '../button/button.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('tag', styles);
var Tag = function (_a) {
  var appearance = _a.appearance,
    children = _a.children,
    disabled = _a.disabled,
    extraClasses = _a.extraClasses,
    outlined = _a.outlined,
    small = _a.small,
    closeProps = _a.closeProps,
    _b = _a.Elem,
    Elem = _b === void 0 ? 'div' : _b,
    rest = __rest(_a, ["appearance", "children", "disabled", "extraClasses", "outlined", "small", "closeProps", "Elem"]);
  var computedDisable = Elem === 'button' ? {
    disabled: disabled
  } : null;
  var tagChildren = ReactUtils.mapRecursively(children, function (child) {
    if (ReactUtils.getElementName(child) === 'Icon') {
      return /*#__PURE__*/React__default__default.cloneElement(child, __assign({
        extraClasses: PropsUtils.handleExtraClasses(child, bem.e('icon'))
      }, small && {
        size: 3
      }));
    }
    return child;
  });
  return /*#__PURE__*/React__default__default.createElement(Elem, __assign({
    className: bem.b([appearance, {
      disabled: disabled,
      outlined: outlined,
      small: small
    }], extraClasses)
  }, computedDisable, rest), tagChildren, closeProps && /*#__PURE__*/React__default__default.createElement(Button, __assign({
    extraClasses: bem.e('close'),
    "aria-label": closeProps.label,
    size: "sm",
    display: "square",
    link: true
  }, closeProps)));
};
Tag.displayName = 'Tag';
Tag.defaultProps = {
  appearance: undefined,
  disabled: false,
  Elem: 'div',
  extraClasses: undefined,
  outlined: false,
  small: false,
  closeProps: undefined
};
Tag.propTypes = {
  children: PropTypes__default.node.isRequired,
  appearance: PropTypes__default.oneOf(TAG_APPEARANCES),
  disabled: PropTypes__default.bool,
  Elem: PropTypes__default.oneOf(TAG_ELEMS),
  extraClasses: PropTypes__default.string,
  outlined: PropTypes__default.bool,
  small: PropTypes__default.bool,
  closeProps: function (_a) {
    var closeProps = _a.closeProps;
    // if has closeProps then must have label and onclick
    if (closeProps) {
      if (!closeProps.label) {
        return new Error('`closeProps.label` is required if you provide `closeProps`');
      }
      if (!closeProps.onClick) {
        return new Error('`closeProps.onClick` is required if you provide `closeProps`');
      }
    }
    return null;
  }
};
var Tag$1 = Injecss(Tag, styles);

export { Tag, Tag$1 as default };
